export default {
    SearchTextfieldID: 'search-textfield',
    ColorSelectClass: 'color-select',
    RunSelectClass: 'run-select',
    QuickSelectButton: 'quick-select-customer-btn',
};
